import AuthService from '../services/auth'

const org = JSON.parse(localStorage.getItem('org'))
const initialState = org
  ? { status: { populated: true }, org }
  : { status: { populated: false }, org: null }

export const init = {
  namespaced: true,
  state: initialState,
  actions: {
    populate ({ commit }, orgCode) {
      console.log('populate called')
      return AuthService.populateOrg(orgCode).then(
        org => {
          commit('getSuccess', org)
          return Promise.resolve(org)
        },
        error => {
          commit('getFailure')
          return Promise.reject(error)
        }
      )
    },
    wipe ({ commit }) {
      localStorage.removeItem('org')
      commit('wipe')
    }
  },
  mutations: {
    getSuccess (state, org) {
      state.status.populated = true
      state.org = org
    },
    getFailure (state) {
      state.status.populated = false
      state.org = null
    },
    wipe (state) {
      state.status.populated = false
      state.org = null
    }
  }
}
